var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-center" }, [
    _c(
      "a",
      {
        staticClass: "resend-link",
        attrs: { disabled: _vm.hasOnGoingCountDown },
        on: { click: _vm.submit }
      },
      [
        _vm.loading !== true
          ? _c("i", { staticClass: "fa fa-refresh" })
          : _vm._e(),
        _vm._v(" "),
        _vm.loading === true
          ? _c("i", { staticClass: "fa fa-spinner fa-spin" })
          : _vm._e(),
        _vm._v(
          "\n\n        " +
            _vm._s(_vm.$t("registration.resend_mail")) +
            "\n\n        "
        ),
        _vm.hasOnGoingCountDown
          ? _c("span", [
              _vm._v(
                "\n            (" +
                  _vm._s(
                    _vm.$t("registration.seconds", { seconds: _vm.countDown })
                  ) +
                  ")\n        "
              )
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-310d46b8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-310d46b8","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/ResendEmailUserCreateComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-310d46b8","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/ResendEmailUserCreateComponent.vue
// module chunks = 1 2 3